import { useParams, Link } from 'react-router-dom'
import { ArrowBack } from '@mui/icons-material'
import { Alert, Button, CircularProgress, Stack } from '@mui/material'
import { useSearchStytchMembers } from '@/services/hooks/stytch'
import Breadcrumb from '@/components/breadcrumbs/Breadcrumb'
import UserDetails from './UserDetails'

export default function UserPage() {
  const { id } = useParams()

  const { members, isPending, isError, queryKey } = useSearchStytchMembers({
    filterQuery: {
      operands: [{ filter_name: 'member_ids', filter_value: [id] }],
      operator: 'AND',
    },
    enabled: !!id,
  })

  const member = members?.[0]

  return (
    <>
      {member && (
        <Breadcrumb label={member.name} url={`/settings/users/${id}`} />
      )}

      {!isPending && !member && (
        <Alert severity="error">
          Unable to load this user.{' '}
          {isError
            ? 'Please try again later.'
            : 'You may not have access or this user does not exist.'}
        </Alert>
      )}

      {isPending ? (
        <Stack alignItems="center" sx={{ p: 4 }}>
          <CircularProgress />
        </Stack>
      ) : (
        <>
          <Button
            sx={{ ml: '-4px', my: 2 }}
            startIcon={<ArrowBack />}
            component={Link}
            to="../"
            variant="text"
          >
            Back to Users
          </Button>
          {member && <UserDetails member={member} queryKey={queryKey} />}
        </>
      )}
    </>
  )
}
